import { render } from "./RequestDetailsDialog.vue?vue&type=template&id=ca1eb278"
import script from "./RequestDetailsDialog.vue?vue&type=script&lang=js"
export * from "./RequestDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__